// The shell remembers two things per browser: which titled groups are open, and whether the sidebar is shown or hidden to the rail.
// localStorage can throw or be empty (private window, blocked site data), so every access is wrapped and the shell works without it.
export const GROUPS_KEY = "hw.shell.groups";
export const SIDEBAR_KEY = "hw.shell.sidebarOpen";

const get = key => {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
};

const set = (key, value) => {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Nothing to do: the choice just does not survive a reload.
  }
};

/** @returns {Object<string, boolean>} group key → open, for the groups the member has toggled. */
export const readGroups = () => {
  try {
    const parsed = JSON.parse(get(GROUPS_KEY) || "{}");

    return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
};

export const writeGroups = groups => set(GROUPS_KEY, JSON.stringify(groups));

/** @returns {boolean} true unless the member hid the sidebar. */
export const readSidebarOpen = () => get(SIDEBAR_KEY) !== "0";

export const writeSidebarOpen = open => set(SIDEBAR_KEY, open ? "1" : "0");
